
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "HamburgerOpenButton3651513085",
      {"classes":{"root":"HamburgerOpenButton3651513085__root","nav":"HamburgerOpenButton3651513085__nav"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  